// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.staging.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  API_URL: 'https://fuzivvceli.execute-api.us-east-1.amazonaws.com/staging/v1',
  AUTH0_DOMAIN: 'linuxfoundation-staging.auth0.com',
  AUTH0_CLIENT_ID: 'R6ILW3v2DZF4GUBUy7yQlLxATOgGZ2s2'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts